"use client";

import { useCatalogFieldHistory, type FieldHistoryFormat } from "../../hooks/useCatalogFieldHistory";
import { FieldHistoryList } from "./FieldHistoryList";

/**
 * The history of one field, fetched only once its popover is open.
 *
 * <p>A component so the lazy read has somewhere to live: the popover renders whatever it is given,
 * and a hook cannot be called conditionally from there. Mounting is what makes `enabled` true, so
 * the request happens when the reviewer asks and not when the row paints — a case review shows
 * dozens of AI fields at once, and eagerly fetching each one's trail would be dozens of requests
 * nobody asked for.
 */
export function FieldHistorySection(
  { caseId, fieldId, recordId, format }: { caseId: number; fieldId: string; recordId?: string; format?: FieldHistoryFormat },
) {
  const history = useCatalogFieldHistory(caseId, fieldId, recordId, true, format);
  return <FieldHistoryList history={history} />;
}
